module.exports = __webpack_public_path__ + "static/media/loader.44271f65.gif";